import { useCallback } from "react";
import classNames from "classnames/bind";

import { QuizAnswerOption, QuizQuestion as QuizQuestionType, GameVisuals } from "../../../gql/graphql";
import styles from "../QuizGame.module.scss";

const cx = classNames.bind(styles);

interface QuizQuestionProps {
  question: QuizQuestionType;
  currentQuestionIndex: number;
  totalQuestions: number;
  gameVisuals: GameVisuals;
  isSubmitting: boolean;
  onAnswerSelect: (option: QuizAnswerOption) => void;
}

export const QuizQuestion = ({
  question,
  currentQuestionIndex,
  totalQuestions,
  gameVisuals,
  isSubmitting,
  onAnswerSelect,
}: QuizQuestionProps) => {
  const handleAnswerClick = useCallback(
    (option: QuizAnswerOption) => {
      if (!isSubmitting) {
        onAnswerSelect(option);
      }
    },
    [isSubmitting, onAnswerSelect],
  );

  return (
    <div className={cx("gameContent")}>
      <div className={cx("questionSection")}>
        <div className={cx("gameHeader")}>
          <div className={cx("questionProgress")}>
            Question <span className={cx("currentQuestion")}>{currentQuestionIndex + 1}</span> of {totalQuestions}
          </div>
        </div>

        <div className={cx("questionContent")}>
          <h2 className={cx("questionText")}>{question.question}</h2>

          {question.image && (
            <img src={question.image.url} alt="Question illustration" className={cx("questionImage")} />
          )}
        </div>
      </div>

      <div className={cx("answersWrapper")}>
        {question.answerOptions.map((option) => (
          <button
            key={option.id}
            type="button"
            className={cx("answerOption", {
              disabled: isSubmitting,
            })}
            onClick={() => handleAnswerClick(option)}
            disabled={isSubmitting}
            style={{
              borderColor: gameVisuals.themeColor,
            }}
          >
            {option.text}
          </button>
        ))}
      </div>
    </div>
  );
};
